export default "__VITE_ASSET__DA0ZAWR3__"